import styled from 'styled-components';

export const THeadRow = styled.tr`
  height: 64px;
  background: #e2bd58;
`;
